export enum FileTypes {
  CV = "cv",
  CERTIFICATE = "Certificate",
  COVER_LETTER = "CoverLetter",
}
